export const getApiErrorMessage = (error: unknown) => {
  const message = (error as { response?: { data?: { message?: unknown } } })?.response?.data
    ?.message;

  return typeof message === "string" && message.trim() ? message : undefined;
};
